import React, { useEffect, useState } from "react";
import "./NewsTicker.scss";

const NewsTicker = () => {
  const [headlines, setHeadlines] = useState([]);

  const defaultHeadlines = [
    "Welcome to Ettiksoft!",
    "We're hiring talented engineers!",
    "Catch us at Expo 2025!"
  ];

  useEffect(() => {
    const API_URL = "/getNews.php";
    // const API_URL = "/getNews.php"; // For production

    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => {
        console.log("🎯 API Headlines:", data.headlines);
        const tickerTexts = Array.isArray(data.headlines) && data.headlines.length > 0
          ? data.headlines
          : defaultHeadlines;
        setHeadlines(tickerTexts);
      })
      .catch((err) => {
        console.error("🚨 Fetch error:", err);
        setHeadlines(defaultHeadlines);
      });
  }, []);

  return (
    <div className="news-ticker-wrapper">
      <div className="ticker-track">
        <div className="ticker-content">
          {headlines.map((headline, index) => (
            <span key={index}>{headline}+++ &nbsp;&nbsp;&nbsp;&nbsp;</span>
          ))}
        </div>
        <div className="ticker-content">
          {headlines.map((headline, index) => (
            <span key={`copy-${index}`}>{headline}+++ &nbsp;&nbsp;&nbsp;&nbsp;</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;
